"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _BaseButton = _interopRequireDefault(require("../../Button/BaseButton"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tflex-grow: 1;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground-color: ", " !important;\n\t", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder: none;\n\tmargin: ", ";\n\tcursor: pointer;\n\tcolor: ", ";\n\tbackground-color: transparent;\n\t&:focus {\n\t\toutline: 0;\n\t}\n\t&.year {\n\t\twidth: calc(50% - ", ");\n\t}\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t}\n\tflex-grow: 1;\n\twidth: calc(33% - ", ");\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var sharedButtonStyles = (0, _styledComponents.css)(_templateObject(), _spacing.default.s1, _colors.default.link, _spacing.default.s2, _colors.default.primaryLighter, _colors.default.linkHover, _spacing.default.s2);
var Button = (0, _styledComponents.default)(_BaseButton.default)(_templateObject2(), sharedButtonStyles);
Button.displayName = 'Button';
var ActiveButton = (0, _styledComponents.default)(_BaseButton.default)(_templateObject3(), _colors.default.primaryLighter, sharedButtonStyles);
ActiveButton.displayName = 'ActiveButton';

var Wrapper = _styledComponents.default.div(_templateObject4());

Wrapper.displayName = 'Wrapper';

var ItemSelector = function ItemSelector(_ref) {
  var selectedItem = _ref.selectedItem,
      onItemSelected = _ref.onItemSelected,
      items = _ref.items,
      className = _ref.className,
      hideSelected = _ref.hideSelected;
  var returnItems = items.map(function (item) {
    if (item === selectedItem && !hideSelected) {
      return _react.default.createElement(ActiveButton, {
        className: className,
        key: item,
        onClick: function onClick() {
          onItemSelected(item);
        }
      }, item);
    }

    return _react.default.createElement(Button, {
      className: className,
      key: item,
      onClick: function onClick() {
        onItemSelected(item);
      }
    }, item);
  });
  return _react.default.createElement(Wrapper, null, returnItems);
};

ItemSelector.displayName = 'ItemSelector';
var _default = ItemSelector;
exports.default = _default;
ItemSelector.propTypes = {
  className: _propTypes.string,
  selectedItem: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  items: (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])).isRequired,
  onItemSelected: _propTypes.func.isRequired,
  hideSelected: _propTypes.bool
};
ItemSelector.defaultProps = {
  selectedItem: null,
  className: null,
  hideSelected: false
};